import request from '@/utils/request'

export function login(user) {
  return request({
    url: '/api/login/login',
    method: 'post',
    data: {
      userName: user.userName, 
      rsaPassWord: user.rsaPassWord, 
      checkCode: user.checkCode, 
      uuid: user.uuid
    }
  })
}

export function getuuid(uuid) {
  return request({
    url: '/api/login/uuid',
    method: 'get',
    params: {
      uuid: uuid
    }
  })
}

export function getInfo() {
  return request({
    url: '/api/login/getuser',
    method: 'get'
  })
}






// WEBPACK FOOTER //
// ./src/api/login.js